import { deleteRequest } from '@/core';
import { locations } from '@/requests';

export default async function deleteLocationRequest(id) {
	let url = locations.getByIdPath(id);
	let response = await deleteRequest(url);
	return response;
}
